// extracted by mini-css-extract-plugin
export default {"dialog":"DeleteCollection_dialog__Ig8Ah","title":"DeleteCollection_title__V51ps","highlight":"DeleteCollection_highlight__APxhN","subtitle":"DeleteCollection_subtitle__VLfQT"};